import { atom } from 'jotai';

/**
 *  Set to true when the template selection (with recommendations) modal is open.
 *  Growth experiment to educate users on note templates, however, this may replace the existing template
 *  selection modal in the future, so keeping the naming more generic
 *  User triggered, does not require a Tier assignment
 */
export const templateSelectionModalOpenAtom = atom(false);
